function vert_tabs() {
  $("ul.checklist-select li").click(function () {
    var e = $(this).attr("id");
    $("ul.checklist-select li").removeClass("active"),
      $(this).addClass("active"),
      $("div.box").removeClass("selected"),
      $("." + e + "-box").addClass("selected"),
      $("ul.checklist-select li").removeClass("active"),
      $(this).addClass("active");
  });
}
$(document).ready(function () {
  vert_tabs(),
    $("ul.checklist-select li:first").addClass("active"),
    $("div.box:first").addClass("selected"),
    $("ul.checklist-select li:first").click();
}),
  $(window).resize(function () {
    $(".vertical-tabs").innerWidth() > 640 &&
      ($("div.selected").length || $("div.box:first").addClass("selected"));
  }),
  640 >= $(window).innerWidth() && $(".accordion").hide(),
  $(".acclinks_mob").on("click", function () {
    var e = $(this);
    e.next(".accordion").slideToggle(400), e.toggleClass("active");
  });
